import * as molecules from '@/components/molecules';
import * as organisms from '@/components/organisms';

export interface ComponentMap {
  // ElementType, not ComponentType<...>: the registry mixes components with
  // very different props, and a precisely-typed component isn't assignable
  // to one that accepts arbitrary props.
  [componentName: string]: React.ElementType;
}

// Gutenberg components (molecules + organisms)
// Theme components (Header, Footer, Layout) are imported directly in App.tsx
const componentsRegistry: ComponentMap = {
  ...molecules,
  ...organisms,
};

class ComponentLoader {
  getAllComponents(): ComponentMap {
    return componentsRegistry;
  }

  getComponent(name: string): React.ElementType | null {
    return componentsRegistry[name] || null;
  }

  hasComponent(name: string): boolean {
    return name in componentsRegistry;
  }

  getComponentNames(): string[] {
    return Object.keys(componentsRegistry);
  }
}

export const componentLoader = new ComponentLoader();